import { debounce } from '@/utils/api';

(function (doc, win) {
	if (!doc.addEventListener) return;

	var docEl = doc.documentElement;
	var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';

	const recalc = () => {
		var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
		var isFF = userAgent.indexOf('Firefox') > -1; //判断是否Firefox浏览器
		var isWindowsPhone = /(?:Windows Phone)/.test(userAgent);
		var isSymbian = /(?:SymbianOS)/.test(userAgent) || isWindowsPhone;
		var isAndroid = /(?:Android)/.test(userAgent);
		var isTablet =
			/(?:iPad|PlayBook)/.test(userAgent) ||
			(isAndroid && !/(?:Mobile)/.test(userAgent)) ||
			(isFF && /(?:Tablet)/.test(userAgent));
		var isPhone = /(?:iPhone)/.test(userAgent) && !isTablet;
		var isPc = !isPhone && !isAndroid && !isSymbian;
		var n = screen.availWidth;
		if (isPc && screen.width / screen.height > 16 / 9) {
			n = (screen.height / 9) * 16;
		}
		console.log('-------------- n', n);
		var n1 = docEl.clientWidth;
		if (n < 1920 && n > 992) {
			docEl.style.fontSize = n1 >= 992 ? 20 * (n / 1920) + 'px' : 20 * (n1 / 750) + 'px';
		} else {
			docEl.style.fontSize = n1 >= 992 ? '20px' : 20 * (n1 / 750) + 'px';
		}
	};

	win.addEventListener(resizeEvt, debounce(recalc, 200), false);
	doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);
